import { DropDownField } from '@/components/shared/CustomField/FieldTemplates/DropDownField';
import { CircularProgress, Stack, Typography } from '@mui/material';

const WALL_LOSS_FACTORS = ['1', '2', '3', '4', '5', '6'];

export const EditWallLossFactor = ({
  currentFactor,
  setCurrentFactor,
  setUpdatedFactor,
  loading,
}: {
  currentFactor: string | undefined;
  setCurrentFactor: (factor: string | undefined) => void;
  setUpdatedFactor: (factor: string) => void;
  loading: boolean;
}) => {
  const handleFactorSelect = (factor: string) => {
    setUpdatedFactor(factor);
    setCurrentFactor(factor);
  };

  return (
    <Stack sx={{ width: '100%', marginTop: '3.2rem' }}>
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <DropDownField
          id="wall-loss-factor"
          title="Wall Loss Factor"
          mode="Edit"
          options={WALL_LOSS_FACTORS}
          value={currentFactor}
          onFieldValueChange={handleFactorSelect}
          placeholder="Select Factor"
          disableClearable={true}
        />
      )}

      <Typography color="primary.light" marginTop="2.4rem" variant="body2">
        <span style={{ fontWeight: 500 }}>Note:</span> Updating the wall loss factor would change
        the wall loss, residual thickness values and residual corrosion allowance values.
      </Typography>
    </Stack>
  );
};
